var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3V7.5H21V3H17.25V3.375C17.25 3.99637 16.7464 4.5 16.125 4.5C15.5036 4.5 15 3.99637 15 3.375V3H9V3.375C9 3.99637 8.49638 4.5 7.875 4.5C7.25362 4.5 6.75 3.99637 6.75 3.375V3H3ZM3 8.25V21H21V9L19.5 8.93701V16.875C19.5 17.625 17.625 17.625 17.625 17.625C17.625 17.625 17.625 19.5 16.5 19.5H4.5V8.31299L3 8.25ZM7.125 10.875V13.125H9.375V10.875H7.125ZM10.875 10.875V13.125H13.125V10.875H10.875ZM14.625 10.875V13.125H16.875V10.875H14.625ZM7.125 14.625V16.875H9.375V14.625H7.125ZM10.875 14.625V16.875H13.125V14.625H10.875ZM14.625 14.625V16.875H16.875V14.625H14.625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.0812c607b5c8dd1b80e4946a4c5d3efb.svg";
export { ForwardRef as ReactComponent };